module.exports = __webpack_public_path__ + "img/GBR.48feb924.svg";